// Simple session storage for quiz state
const KEY_ANSWERS = 'ai-quiz-answers'
const KEY_LEAD = 'ai-quiz-lead'

export interface LeadInfo {
  name: string
  email: string
  company: string
  role: string
  consent: boolean
}

export function saveAnswers(answers: Record<string, number>) {
  try {
    sessionStorage.setItem(KEY_ANSWERS, JSON.stringify(answers))
  } catch {}
}

export function loadAnswers(): Record<string, number> {
  try {
    const raw = sessionStorage.getItem(KEY_ANSWERS)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export function saveLead(lead: LeadInfo) {
  try {
    sessionStorage.setItem(KEY_LEAD, JSON.stringify(lead))
  } catch {}
}

export function loadLead(): LeadInfo | null {
  try {
    const raw = sessionStorage.getItem(KEY_LEAD)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function clearAll() {
  try {
    sessionStorage.removeItem(KEY_ANSWERS)
    sessionStorage.removeItem(KEY_LEAD)
  } catch {}
}
